import { render, staticRenderFns } from "./AssignmentGradingActivities.vue?vue&type=template&id=2b54632c&scoped=true"
import script from "./AssignmentGradingActivities.vue?vue&type=script&lang=js"
export * from "./AssignmentGradingActivities.vue?vue&type=script&lang=js"
import style0 from "./AssignmentGradingActivities.vue?vue&type=style&index=0&id=2b54632c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b54632c",
  null
  
)

export default component.exports